import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../components/Loader/Loader";
import { useState } from "react";
import CommonItemSearch from "../../../components/ItemSearch/CommonItemSearch";
import axios from "axios";
import config from "../../../config/config";
import Select from "react-select";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";
import moment from "moment";
import { toastError } from "../../../common/Toast";

const InventoryValuationReport = () => {
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("Token");
  const [paymentDate, setPaymentDate] = useState(moment().format("YYYY-MM-DD"));
  const [StartDate, setStartDate] = useState("");
  const [itemoption, setItemoption] = useState([]);

  const [responseData, setResponseData] = useState([]);

  console.log(itemoption, "itemoption");

  const callbackItemSearch = async (payloads) => {
    if (!Array.isArray(payloads) || payloads.length === 0) return;
    const item = payloads[0];

    setItemoption([
      ...itemoption,
      {
        label: item.VariationId > 0 ? item?.VariationName : item?.ItemName,
        value: item.VariationId > 0 ? item.VariationId : item.ItemId,
        ItemType: item.VariationId > 0 ? "Variation" : "Item",
      },
    ]);
  };

  const HandleItemclear = (e) => {
    console.log("HandleItemclear", e);
    setItemoption([]);
  };

  const handleDateChange = (newDate) => {
    setPaymentDate(newDate);
  };

  const apicall = () => {
    setLoading(true);
    if (itemoption.length === 0) {
      toastError("Select Item ");
      return;
    }
    const Itemobj = {};
    Itemobj.saleitemsXML = itemoption;
    let itemjsonstring = JSON.stringify(Itemobj);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/InventoryValuationReport?startdate=${StartDate}&enddate=${paymentDate}&ItemId=${itemjsonstring}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        return;
      });
  };

  const headerMenu = function () {
    const table = this;
    const menu = [];
    const columns = table.getColumns();

    // Check if we have saved visibility state in localStorage
    const savedVisibility = localStorage.getItem("columnVisibility");
    const visibilityState = savedVisibility ? JSON.parse(savedVisibility) : {};

    for (let column of columns) {
      const field = column.getField();
      const columnDef = column.getDefinition();
      const defaultVisible = columnDef.defaultVisible == true; // Default to true if not specified

      console.log(visibilityState, "visibilityState", defaultVisible);

      // Determine initial visibility:
      // 1. Use saved state if available
      // 2. Fall back to defaultVisible if no saved state
      const shouldBeVisible = visibilityState.hasOwnProperty(field)
        ? visibilityState[field]
        : defaultVisible;

      // Set column visibility
      if (shouldBeVisible) {
        column.show();
      } else {
        column.hide();
      }

      // Create menu item with icon
      const icon = document.createElement("i");
      icon.classList.add("fas");
      icon.classList.add(column.isVisible() ? "fa-check-square" : "fa-square");

      const label = document.createElement("span");
      const title = document.createElement("span");
      title.textContent = " " + columnDef.title;
      label.appendChild(icon);
      label.appendChild(title);

      menu.push({
        label: label,
        action: function (e) {
          e.stopPropagation();

          // Toggle visibility
          const newVisibility = !column.isVisible();
          if (newVisibility) {
            column.show();
            icon.classList.remove("fa-square");
            icon.classList.add("fa-check-square");
          } else {
            column.hide();
            icon.classList.remove("fa-check-square");
            icon.classList.add("fa-square");
          }

          // Update and save visibility state
          visibilityState[field] = newVisibility;
          localStorage.setItem(
            "columnVisibility",
            JSON.stringify(visibilityState)
          );
        },
      });
    }

    return menu;
  };

  const columns = [
    {
      title: "Item Name",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "label",
      frozen: true,
      defaultVisible: true,
    },
    {
      title: "TransactionDate",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "TransactionDate",
      defaultVisible: true,
    },
    {
      title: "Quantity",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "Quantity",
      defaultVisible: true,
    },
    {
      title: "Type",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "Type",
      frozen: true,
      defaultVisible: true,
    },
    {
      title: "QtyInHand",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "QtyInHand",
      defaultVisible: true,
    },
    {
      title: "UnitCost",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "UnitCost",
      defaultVisible: true,
    },
    {
      title: "InventoryValue",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "InventoryValue",
      frozen: true,
      defaultVisible: true,
    },
    {
      title: "Assestvalue",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "Assestvalue",
      defaultVisible: true,
    },
  ];

  useEffect(() => {
    localStorage.removeItem("columnVisibility");
  }, []);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Customer Balance Detail</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Inventory Valuation Report
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                {" "}
                Item Search{" "}
              </label>
              <CommonItemSearch
                callback={callbackItemSearch}
                value={1}
                callbackaccount={() => {}}
              />
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                {" "}
                Selected Item
              </label>
              <Select
                options={itemoption}
                value={itemoption}
                onChange={HandleItemclear}
                isMulti
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                isClearable={true}
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                className="custom-search-select"
              />
            </div>

            <div className="col-sm-2 align-self-sm-end">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                {" "}
                As of Date :
              </label>
              <CommonDatePicker
                FinalDate={paymentDate}
                handleDateChange={handleDateChange}
              />
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>

          {responseData.length > 0 && (
            <div className="card mt-3">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center " id="header">
                    <h6 class="p">SonarPos</h6>
                    <p className="fw-bold p-regular">
                      Inventory Valuation Report
                    </p>
                  </div>
                </div>
                <hr />

                <div className="table-responsive">
                  <div className="table mt-3"></div>

                  <div>
                    <CommonTabular
                      Data={responseData}
                      columns={columns}
                      Groupvalue={["label"]}
                      Reportname={"Inventory Valuation Report"}
                      frozenRowvalue={0}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default InventoryValuationReport;
